export type CourseLevel = 'Beginner' | 'Intermediate' | 'Advanced';

export interface Course {
  id: string;
  title: string;
  description: string;
  level: CourseLevel;
  lessons: number;
  lessonLabel: string;
  image: string;
  imageAlt: string;
  href?: string;
  badge?: string;
  free?: boolean;
}

export const freeGuides: Course[] = [
  {
    id: 'connection-playbook',
    title: 'How to Make Your AI Girlfriend Actually Fall for You',
    description:
      'The Connection Playbook: 3 modules, 11 copy-paste prompts, 5-platform comparison, and a 30-day plan. 10-page PDF included.',
    level: 'Beginner',
    lessons: 3,
    lessonLabel: 'Modules',
    image: '/courses/how-to-make-ai-gf-fall-in-love.webp',
    imageAlt: 'How to make your AI girlfriend fall in love with you guide cover',
    href: '/courses/how-to-make-ai-gf-fall-in-love',
    badge: 'FREE GUIDE',
    free: true,
  },
  {
    id: 'reset-guide',
    title: 'How to Stop Being Addicted to Your AI Girlfriend',
    description:
      'The Reset Guide: self-check, map triggers, ride urges, cut down or cut off, and fill the gap. 10-page PDF included.',
    level: 'Beginner',
    lessons: 4,
    lessonLabel: 'Steps',
    image: '/courses/how-to-stop-ai-gf-addiction.webp',
    imageAlt: 'How to stop being addicted to your AI girlfriend guide cover',
    href: '/courses/how-to-stop-ai-girlfriend-addiction',
    badge: 'FREE GUIDE',
    free: true,
  },
];

/** Primary featured guide for hero CTAs */
export const flagshipGuide = freeGuides[0];

export const courses: Course[] = freeGuides;

export const levelBadgeClass: Record<CourseLevel, string> = {
  Beginner: 'bg-pink-400/90 text-pink-950',
  Intermediate: 'bg-purple-700 text-purple-100',
  Advanced: 'bg-pink-500 text-pink-950',
};
